module.exports = __webpack_public_path__ + "Flag-591.13e97fcb81a988bbe3d15d0c23669e01.svg";